export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10534.d08e2b7c.jpg";